module.exports = __webpack_public_path__ + "static/Time_to_CABG-26f9780b12a045582078538eb0a35781.png";